import { ThemeColor } from "./OutputLanguageSelector";

export const acceptedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "text/plain": [".txt"],
};

export const gradientClasses: Record<ThemeColor, string> = {
  red: "from-red-600 to-orange-600 dark:from-red-400 dark:to-orange-400",
  orange: "from-orange-600 to-red-600 dark:from-orange-400 dark:to-red-400",
  blue: "from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400",
  teal: "from-teal-600 to-emerald-600 dark:from-teal-400 dark:to-emerald-400",
  cyan: "from-cyan-600 to-cyan-500 dark:from-cyan-400 dark:to-cyan-300",
  rose: "from-rose-600 to-red-600 dark:from-rose-400 dark:to-red-400",
  stone: "from-stone-600 to-stone-500 dark:from-stone-400 dark:to-stone-300",
  lime: "from-lime-600 to-lime-500 dark:from-lime-400 dark:to-lime-300",
  terra: "from-[#D98787] to-[#C65151] dark:from-[#E9A3A3] dark:to-[#D67272]",
  purple:
    "from-purple-600 to-purple-500 dark:from-purple-400 dark:to-purple-300",
  amber: "from-amber-600 to-yellow-600 dark:from-amber-400 dark:to-yellow-400",
  emerald:
    "from-emerald-600 to-green-600 dark:from-emerald-400 dark:to-green-400",
  violet:
    "from-violet-600 to-purple-600 dark:from-violet-400 dark:to-purple-400",
  slate: "from-slate-600 to-slate-500 dark:from-slate-400 dark:to-slate-300",
  yellow: "from-yellow-600 to-amber-600 dark:from-yellow-400 dark:to-amber-400",
  fuchsia:
    "from-fuchsia-600 to-pink-600 dark:from-fuchsia-400 dark:to-pink-400",
  zinc: "from-zinc-600 to-zinc-500 dark:from-zinc-400 dark:to-zinc-300",
  green:
    "from-green-600 to-emerald-600 dark:from-green-400 dark:to-emerald-400",
  coral: "from-red-400 to-pink-500 dark:from-red-300 dark:to-pink-400",
  mint: "from-green-400 to-teal-500 dark:from-green-300 dark:to-teal-400",
  lavender:
    "from-purple-400 to-indigo-500 dark:from-purple-300 dark:to-indigo-400",
  sunset: "from-orange-400 to-rose-500 dark:from-orange-300 dark:to-rose-400",
  ocean: "from-blue-400 to-cyan-500 dark:from-blue-300 dark:to-cyan-400",
  bloom: "from-[#F3C969] to-[#81C784] dark:from-[#FFD54F] dark:to-[#66BB6A]",
  cream: "from-[#BFA58A] to-[#A07E5E] dark:from-[#C8B08D] dark:to-[#D67272]",
};

export const buttonClasses: Record<ThemeColor, string> = {
  red: "bg-red-500 dark:bg-red-600 hover:bg-red-600 dark:hover:bg-red-700",
  orange:
    "bg-orange-500 dark:bg-orange-600 hover:bg-orange-600 dark:hover:bg-orange-700",
  blue: "bg-blue-500 dark:bg-blue-600 hover:bg-blue-600 dark:hover:bg-blue-700",
  teal: "bg-teal-500 dark:bg-teal-600 hover:bg-teal-600 dark:hover:bg-teal-700",
  cyan: "bg-cyan-500 dark:bg-cyan-600 hover:bg-cyan-600 dark:hover:bg-cyan-700",
  rose: "bg-rose-500 dark:bg-rose-600 hover:bg-rose-600 dark:hover:bg-rose-700",
  stone:
    "bg-stone-500 dark:bg-stone-600 hover:bg-stone-600 dark:hover:bg-stone-700",
  lime: "bg-lime-500 dark:bg-lime-600 hover:bg-lime-600 dark:hover:bg-lime-700",
  terra:
    "bg-[#D98787] dark:bg-[#C65151] hover:bg-[#C65151] dark:hover:bg-[#D67272]",
  purple:
    "bg-purple-500 dark:bg-purple-600 hover:bg-purple-600 dark:hover:bg-purple-700",
  amber:
    "bg-amber-500 dark:bg-amber-600 hover:bg-amber-600 dark:hover:bg-amber-700",
  emerald:
    "bg-emerald-500 dark:bg-emerald-600 hover:bg-emerald-600 dark:hover:bg-emerald-700",
  violet:
    "bg-violet-500 dark:bg-violet-600 hover:bg-violet-600 dark:hover:bg-violet-700",
  slate:
    "bg-slate-500 dark:bg-slate-600 hover:bg-slate-600 dark:hover:bg-slate-700",
  yellow:
    "bg-yellow-500 dark:bg-yellow-600 hover:bg-yellow-600 dark:hover:bg-yellow-700",
  fuchsia:
    "bg-fuchsia-500 dark:bg-fuchsia-600 hover:bg-fuchsia-600 dark:hover:bg-fuchsia-700",
  zinc: "bg-zinc-500 dark:bg-zinc-600 hover:bg-zinc-600 dark:hover:bg-zinc-700",
  green:
    "bg-green-500 dark:bg-green-600 hover:bg-green-600 dark:hover:bg-green-700",
  coral: "bg-red-400 dark:bg-red-500 hover:bg-red-500 dark:hover:bg-red-600",
  mint: "bg-green-400 dark:bg-green-500 hover:bg-green-500 dark:hover:bg-green-600",
  lavender:
    "bg-purple-400 dark:bg-purple-500 hover:bg-purple-500 dark:hover:bg-purple-600",
  sunset:
    "bg-orange-400 dark:bg-orange-500 hover:bg-orange-500 dark:hover:bg-orange-600",
  ocean:
    "bg-blue-400 dark:bg-blue-500 hover:bg-blue-500 dark:hover:bg-blue-600",
  bloom:
    "bg-[#F3C969] dark:bg-[#FFD54F] hover:bg-[#81C784] dark:hover:bg-[#66BB6A]",
  cream:
    "bg-[#BFA58A] dark:bg-[#A07E5E] hover:bg-[#A07E5E] dark:hover:bg-[#C8B08D]",
};

export const submitGradientClasses: Record<ThemeColor, string> = {
  red: "from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700",
  orange: "from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700",
  blue: "from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700",
  teal: "from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700",
  cyan: "from-cyan-600 to-cyan-500 hover:from-cyan-700 hover:to-cyan-600",
  rose: "from-rose-600 to-red-600 hover:from-rose-700 hover:to-red-700",
  stone: "from-stone-600 to-stone-500 hover:from-stone-700 hover:to-stone-600",
  lime: "from-lime-600 to-lime-500 hover:from-lime-700 hover:to-lime-600",
  terra: "from-[#D98787] to-[#C65151] hover:from-[#C65151] hover:to-[#B64444]",
  purple:
    "from-purple-600 to-purple-500 hover:from-purple-700 hover:to-purple-600",
  amber:
    "from-amber-600 to-yellow-600 hover:from-amber-700 hover:to-yellow-700",
  emerald:
    "from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700",
  violet:
    "from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700",
  slate: "from-slate-600 to-slate-500 hover:from-slate-700 hover:to-slate-600",
  yellow:
    "from-yellow-600 to-amber-600 hover:from-yellow-700 hover:to-amber-700",
  fuchsia:
    "from-fuchsia-600 to-pink-600 hover:from-fuchsia-700 hover:to-pink-700",
  zinc: "from-zinc-600 to-zinc-500 hover:from-zinc-700 hover:to-zinc-600",
  green:
    "from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700",
  coral: "from-red-400 to-pink-500 hover:from-red-500 hover:to-pink-600",
  mint: "from-green-400 to-teal-500 hover:from-green-500 hover:to-teal-600",
  lavender:
    "from-purple-400 to-indigo-500 hover:from-purple-500 hover:to-indigo-600",
  sunset: "from-orange-400 to-rose-500 hover:from-orange-500 hover:to-rose-600",
  ocean: "from-blue-400 to-cyan-500 hover:from-blue-500 hover:to-cyan-600",
  bloom: "from-[#F3C969] to-[#81C784] hover:from-[#FFD54F] hover:to-[#66BB6A]",
  cream: "from-[#BFA58A] to-[#A07E5E] hover:from-[#A07E5E] hover:to-[#C8B08D]",
};

export const labelClasses: Record<ThemeColor, string> = {
  red: "text-red-700 dark:text-red-300",
  orange: "text-orange-700 dark:text-orange-300",
  blue: "text-blue-700 dark:text-blue-300",
  teal: "text-teal-700 dark:text-teal-300",
  cyan: "text-cyan-700 dark:text-cyan-300",
  rose: "text-rose-700 dark:text-rose-300",
  stone: "text-stone-700 dark:text-stone-300",
  lime: "text-lime-700 dark:text-lime-300",
  terra: "text-[#C65151] dark:text-[#E9A3A3]",
  purple: "text-purple-700 dark:text-purple-300",
  amber: "text-amber-700 dark:text-amber-300",
  emerald: "text-emerald-700 dark:text-emerald-300",
  violet: "text-violet-700 dark:text-violet-300",
  slate: "text-slate-700 dark:text-slate-300",
  yellow: "text-yellow-700 dark:text-yellow-300",
  fuchsia: "text-fuchsia-700 dark:text-fuchsia-300",
  zinc: "text-zinc-700 dark:text-zinc-300",
  green: "text-green-700 dark:text-green-300",
  coral: "text-red-700 dark:text-red-300",
  mint: "text-green-700 dark:text-green-300",
  lavender: "text-purple-700 dark:text-purple-300",
  sunset: "text-orange-700 dark:text-orange-300",
  ocean: "text-blue-700 dark:text-blue-300",
  bloom: "text-bloomsTaxonomy dark:text-bloomsTaxonomyDark",
  cream: "text-[#8D6B4E] dark:text-[#C8B08D]",
};
